var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 19.1666C4.93739 19.1666 0.833332 15.0625 0.833332 9.99992C0.833332 4.93731 4.93739 0.833252 10 0.833252C15.0626 0.833252 19.1667 4.93731 19.1667 9.99992C19.1667 15.0625 15.0626 19.1666 10 19.1666ZM10 17.4999C14.1421 17.4999 17.5 14.1421 17.5 9.99992C17.5 5.85778 14.1421 2.49992 10 2.49992C5.85786 2.49992 2.5 5.85778 2.5 9.99992C2.5 14.1421 5.85786 17.4999 10 17.4999ZM14.1667 9.16658H10.8333V4.99992H9.16667V10.8333H14.1667V9.16658Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockAlt);
export default __webpack_public_path__ + "static/media/clock-alt.674d86dc.svg";
export { ForwardRef as ReactComponent };